/**
 * 산업재해현황(ACS_BASIC_01) 컬럼 정의
 * 순번, 발생일시, 부서, 직급, 성명(설정하기), 입사일, 전화번호, 발생장소, 공정(기인물), 재해발생형태, 상해종류,
 * 사고경위, 조치, 원인, 개선대책, 휴업(예상)일수, 복귀(예정)일자, 산업재해보상보험 신청여부,
 * 산업재해조사표, 사고경위서, 비고
 * - 컬럼명이 길 경우 개행: wrapHeaderText + headerClass 'ag-header-cell-wrap'
 */

import { CreateColumn } from '../../../../Services/agGrid/createColumn';

const headerWrap = { wrapHeaderText: true, headerClass: 'ag-header-cell-wrap' };

export const getColumnDefs1 = (props) => {
  return [
    CreateColumn('no', 'NO', 'center', 80, false, false, false, 'checkbox', {
      checkboxProps: {
        DeleteNewRow: props.DeleteNewRow1,
        RestoreRow: props.RestoreRow1,
        gridRef: props.gridRef1,
        rowData: props.rowData1,
        selectedRowNosRef: props.selectedRowNosRef1,
        lastCheckedIndexRef: props.lastCheckedIndexRef1,
        handleRowSelection: props.handleRowSelection1,
      },
      maxWidth: 100,
      ...headerWrap,
    }),
    CreateColumn(
      'accidentSeq',
      '순번',
      'center',
      80,
      false,
      false,
      true,
      'text',
      {
        minWidth: 130,
        ...headerWrap,
      }
    ),
    CreateColumn(
      'accidentDate',
      '발생일시',
      'center',
      150,
      true,
      true,
      false,
      'datetime',
      {
        dateFormat: 'YYYY-MM-DD HH:mm:ss',
        minWidth: 150,
        ...headerWrap,
      }
    ),
    CreateColumn('depNm', '부서', 'left', 150, false, true, false, 'text', {
      minWidth: 150,
      cellClass: 'none-editable-cell',
      tooltip: '성명 설정 시 자동 입력됩니다.',
      ...headerWrap,
    }),
    CreateColumn('rank', '직급', 'left', 150, false, false, false, 'text', {
      minWidth: 150,
      cellClass: 'none-editable-cell',
      tooltip: '성명 설정 시 자동 입력됩니다.',
      ...headerWrap,
    }),
    CreateColumn(
      'victimName',
      '성명',
      'center',
      130,
      false,
      true,
      false,
      'requiredButton',
      {
        buttonClickHandler: (params) => {
          if (params.data?.newYn === 'Y') {
            props.PopupClickEvent1?.(params);
          }
        },
        buttonEmptyText: '설정하기',
        buttonEmptyTooltip: '성명은 필수입니다.',
        buttonValueTooltip: (params) => {
          const isNew = params.data?.newYn === 'Y';
          return isNew
            ? '재설정 시 클릭하세요.'
            : '저장된 데이터는 수정할 수 없습니다.';
        },
        cellClassRules: {
          'required-cell': (params) => {
            const value = params.value;
            if (typeof value === 'string') return value.trim() === '';
            return !value;
          },
          'none-editable-cell': (params) => params.data?.newYn !== 'Y',
        },
        ...headerWrap,
      }
    ),
    CreateColumn(
      'joinDate',
      '입사일',
      'center',
      120,
      true,
      false,
      false,
      'date',
      {
        minWidth: 120,
        ...headerWrap,
      }
    ),
    CreateColumn('tel', '전화번호', 'left', 140, false, true, false, 'text', {
      minWidth: 120,
      cellClass: 'none-editable-cell',
      tooltip: '성명 설정 시 자동 입력됩니다.',
      ...headerWrap,
    }),
    CreateColumn(
      'location',
      '발생장소',
      'left',
      130,
      true,
      false,
      false,
      'text',
      {
        flex: 1,
        minWidth: 110,
      tooltipValueGetter: () => '사고가 발생한 장소를 입력합니다.',
        ...headerWrap,
      }
    ),
    CreateColumn(
      'gongjongNm',
      '공정(기인물)',
      'left',
      180,
      false,
      true,
      false,
      'requiredButton',
      {
        flex: 1,
        minWidth: 180,
        buttonClickHandler: (params) => {
          props.PopupGongjongClickEvent?.(params);
        },
        buttonEmptyText: '설정하기',
        buttonEmptyTooltip:
          '부서·공정을 고르거나, 목록에 없으면 모달의 「기타 선택」 후 재해발생형태 또는 사고경위에 상세히 적어 주세요.',
        buttonValueTooltip: (params) => {
          const nm = params.value;
          const cd = params.data?.gongjongCd;
          const isOther = nm === '기타' || String(cd ?? '') === '0' || cd === 0;
          if (isOther) {
            return '「기타」(공정코드 0)입니다. 재해발생형태 또는 사고경위에 구체적인 설명을 입력했는지 확인하세요. 클릭하면 부서·공정을 다시 고를 수 있습니다.';
          }
          return nm
            ? '클릭 후 공정을 바꾸거나 「기타 선택」을 이용할 수 있습니다.'
            : '클릭하여 부서·공정을 선택하세요. 목록에 없으면 「기타 선택」 후 재해발생형태 또는 사고경위에 상세히 적어 주세요.';
        },
        ...headerWrap,
      }
    ),
    CreateColumn(
      'accidentType',
      '재해발생형태',
      'left',
      150,
      true,
      false,
      false,
      'text',
      {
        minWidth: 150,
        ...headerWrap,
      }
    ),
    CreateColumn(
      'injuryType',
      '상해종류',
      'left',
      150,
      true,
      false,
      false,
      'text',
      {
        minWidth: 150,
        ...headerWrap,
      }
    ),
    CreateColumn(
      'accidentDesc',
      '사고경위',
      'left',
      150,
      true,
      true,
      false,
      'text',
      {
        flex: 1,
        minWidth: 150,
        ...headerWrap,
      }
    ),
    CreateColumn(
      'actionTaken',
      '조치',
      'left',
      150,
      true,
      false,
      false,
      'text',
      {
        flex: 1,
        minWidth: 150,
        ...headerWrap,
      }
    ),
    CreateColumn('causeDesc', '원인', 'left', 150, true, false, false, 'text', {
      flex: 1,
      minWidth: 150,
      ...headerWrap,
    }),
    CreateColumn(
      'preventMeasure',
      '개선대책',
      'left',
      150,
      true,
      false,
      false,
      'text',
      {
        flex: 1,
        minWidth: 150,
        ...headerWrap,
      }
    ),
    CreateColumn(
      'leaveDays',
      '휴업(예상)일수',
      'center',
      120,
      true,
      false,
      false,
      'text',
      {
        minWidth: 120,
        ...headerWrap,
      }
    ),
    CreateColumn(
      'returnDate',
      '복귀(예정)일자',
      'center',
      120,
      false,
      false,
      false,
      'date',
      {
        minWidth: 120,
        editableCondition: (params) => {
          const v = params.data?.leaveDays;
          if (v == null) return false;
          const str = String(v).trim();
          if (str === '') return false;
          const n = Number(str);
          return !Number.isNaN(n) && n > 0;
        },
        ...headerWrap,
      }
    ),
    CreateColumn(
      'compInsuranceStat',
      '산업재해보상보험 신청여부',
      'center',
      150,
      true,
      false,
      false,
      'select',
      {
        minWidth: 150,
        selectOptions: ['신청', '미신청'],
        ...headerWrap,
      }
    ),
    CreateColumn(
      'investigationStatFileName',
      '산업재해조사표',
      'center',
      160,
      false,
      false,
      false,
      'fileButton',
      {
        fileButtonClickHandler: (data) => {
          props.PopupFileClickEvent?.(data, 'investigationStatFile');
        },
        ...headerWrap,
      }
    ),
    CreateColumn(
      'reportFileName',
      '사고경위서',
      'center',
      160,
      false,
      false,
      false,
      'fileButton',
      {
        fileButtonClickHandler: (data) => {
          props.PopupFileClickEvent?.(data, 'reportFile');
        },
        ...headerWrap,
      }
    ),
    CreateColumn('remark', '비고', 'left', 150, true, false, false, 'text', {
      flex: 1,
      minWidth: 150,
      ...headerWrap,
    }),
    CreateColumn(
      'victimId',
      'victimId',
      'left',
      80,
      false,
      false,
      true,
      'text',
      {
        ...headerWrap,
      }
    ),
    CreateColumn(
      'gongjongCd',
      'gongjongCd',
      'left',
      80,
      false,
      false,
      true,
      'text',
      {
        ...headerWrap,
      }
    ),
  ];
};
